module.exports = __webpack_public_path__ + "img/partner19.3a1c9081.png";